var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogokma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 302 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.21138,0,0,1.19679,-63.4146,-27.6908)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 177,
    cy: 158.5,
    rx: 123,
    ry: 124.5,
    style: {
      fill: "rgb(20,21,19)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-12,3)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "66px",
    y: "134px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: "89.347px",
      fill: "white"
    }
  }, "KMA")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1,7)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "61px",
    y: "250px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: "154.961px",
      fill: "white"
    }
  }, "75")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogokma);
export default __webpack_public_path__ + "static/media/logokma.39f199b9775ce921cf8e8de9f936eeee.svg";
export { ForwardRef as ReactComponent };